namespace InvData {

    export enum ResourceTypeIds {
        Entity = 1,
        Investment = 2,
        Transaction = 3,
        Contact = 4,
        Note = 5,
        ReportDefinition = 6,
        PropertyDefinition = 7,
        TagSet = 8,
        User = 9,
        ReportDataSource = 10,
        LiquidityModel = 11,
        Manager = 12
    }

}

namespace InvData.ResourceTypeIds {

    export function getName(resourceTypeId: number): string {
        switch (resourceTypeId) {
            case 1: return "Entity";
            case 2: return "Investment";
            case 3: return "Transaction";
            case 4: return "Contact";
            case 5: return "Note";
            case 6: return "ReportDefinition";
            case 7: return "PropertyDefinition";
            case 8: return "TagSet";
            case 9: return "User";
            case 10: return "ReportDataSource";
            case 11: return "LiquidityModel";
            case 12: return "Manager";

            default: return "ResourceTypeId=" + resourceTypeId;
        }
    }

}   